import React, { Component } from "react";
import Chip from "@material-ui/core/Chip";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Datetime from "react-datetime";
import moment from "moment";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DownloadExcel from "./downloadexceltabtrack";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
// import api
import { fetchShiprtbt } from "../../api/portal";
import {
  pushShipTrack,
  pushShipTrack2,
  pushVesselPointTrack,
  pushSourceAis
} from "../../actions/portal";
import { Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import _ from "lodash";

class Tabtrack extends Component {
  constructor(props) {
    super(props);
    const { datanya } = this.props;

    this.tableRef = React.createRef();

    this.state = {
      source: "GPS",
      ship_id: "",
      shipname: "",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      datanya: datanya,
      dataship: [],
      rowselected: 0,
      selectedRow: null,
      call_sign: "",
      loading: "",
      openAlert: false,
      sourceGpsAis: false,
      sourceAis: false,
      sourceGPS: true
    };
  }

  componentWillMount() {
    let startdate = new Date(moment().format("YYYY-MM-DD"));
    //startdate.setHours(-24);
    startdate.setDate(startdate.getDate() - 1);

    let endDate = new Date(moment().format("YYYY-MM-DD"));

    this.setState({
      startDate: moment(startdate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD")
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let datax = nextProps.datanya;
    this.setState({
      ship_id: datax.ship_id,
      shipname: datax.shipname,
      // source: nextProps.sourceAis,
      dataship: [],
      call_sign: datax.call_sign
    });
  }

  handleKeyUp = e => {
    let rowselected = this.state.selectedRow;
    let rec = 0;
    let latlon = [];

    switch (e.keyCode) {
      case 38:
        rec = parseInt(rowselected) - 1;
        this.setState({ selectedRow: rec });
        latlon = this.state.dataship[rec];
        if (latlon) {
          this.props.pushVesselPointTrack([
            latlon.lat,
            latlon.lon,
            latlon.date_created,
            latlon.speed
          ]);
        }
        break;

      case 40:
        rec = parseInt(rowselected) + 1;
        this.setState({ selectedRow: rec });
        latlon = this.state.dataship[rec];
        if (latlon) {
          this.props.pushVesselPointTrack([
            latlon.lat,
            latlon.lon,
            latlon.date_created,
            latlon.speed
          ]);
        }
        break;
    }
  };

  componentDidMount() {
    window.addEventListener("keyup", this.handleKeyUp);
  }

  normalizeTrackResults = results => {
    let i = 0;

    if (!Array.isArray(results)) {
      return [];
    }

    return results
      .filter(e => {
        const lon = parseFloat(e.lon);
        const lat = parseFloat(e.lat);

        return Number.isFinite(lon) && Number.isFinite(lat);
      })
      .map(e => ({
        keynya: i++,
        date_created: e.date_created,
        lat: e.lat,
        lon: e.lon,
        speed: Number.isFinite(parseFloat(e.speed)) ? e.speed : 0,
        call_sign: this.state.call_sign
      }));
  };

  buildTrackPayload = results => {
    if (!Array.isArray(results) || results.length < 2) {
      return [];
    }

    return results
      .map(e => [
        parseFloat(e.lon).toFixed(4),
        parseFloat(e.lat).toFixed(4),
        e.date_created,
        Number.isFinite(parseFloat(e.speed)) ? e.speed : 0
      ])
      .toString();
  };

  getTrackGpsAis = () => {
    let dateStart = new Date(this.state.startDate);
    dateStart.setHours(0, 0, 0, 0);
    let dateEnd = new Date(this.state.endDate);
    dateEnd.setHours(24, 0, 0, 0);

    let timeStart = moment(dateStart).format("YYYY-MM-DD HH:mm:ss");
    let timeEnd = moment(dateEnd).format("YYYY-MM-DD HH:mm:ss");

    this.setState({ loading: "Loading..." });

    fetchShiprtbt(this.state.ship_id, timeStart, timeEnd, "GPS")
      .then(response => {
        fetchShiprtbt(this.state.ship_id, timeStart, timeEnd, "AIS_MT")
          .then(response1 => {
            let gpsTrack = this.normalizeTrackResults(response.data.results);
            let aisTrack = this.normalizeTrackResults(response1.data.results);
            let dataTrack = _.concat(
              gpsTrack,
              aisTrack
            );
            let trackData = _.orderBy(dataTrack, ["date_created"], ["desc"]);

            if (trackData.length > 1) {
              this.setState({ dataship: trackData, loading: "" });
              this.props.pushShipTrack(this.buildTrackPayload(gpsTrack));
              this.props.pushShipTrack2(this.buildTrackPayload(aisTrack));
            } else {
              this.setState({ loading: "No Data" });
            }
          })
          .catch(error => {
            console.log(error);
            //this.props.history.push("/pages/login#logout");
          });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: "No Data" });
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleShow = event => {
    this.props.pushShipTrack([]);
    this.props.pushShipTrack2([]);
    event.preventDefault();
    let start = new Date(this.state.startDate);
    start.setHours(0, 0, 0, 0);
    let end = new Date(this.state.endDate);
    end.setHours(24, 0, 0, 0);

    let threeMonthsAgo = new Date(moment().subtract(3, "months"));
    let fiveDays = start.setDate(start.getDate() + 5);

    if (start < threeMonthsAgo && end > fiveDays) {
      this.setState({ openAlert: true });
    } else {
      if (this.state.source === "GPSAIS") {
        this.getTrackGpsAis();
      } else {
        let dateStart = new Date(this.state.startDate);
        dateStart.setHours(0, 0, 0, 0);
        let dateEnd = new Date(this.state.endDate);
        dateEnd.setHours(24, 0, 0, 0);

        let timeStart = moment(dateStart).format("YYYY-MM-DD HH:mm:ss");
        let timeEnd = moment(dateEnd).format("YYYY-MM-DD HH:mm:ss");

        this.setState({ loading: "Loading..." });

        fetchShiprtbt(this.state.ship_id, timeStart, timeEnd, this.state.source)
          .then(response => {
            let dataxx = this.normalizeTrackResults(response.data.results);

            if (dataxx.length > 1) {
              this.setState({ dataship: dataxx, loading: "" });
              this.props.pushShipTrack(this.buildTrackPayload(dataxx));
            } else {
              this.setState({ loading: "No Data" });
            }
          })
          .catch(error => {
            console.log(error);
            this.setState({ loading: "No Data" });
            //this.props.history.push("/pages/login#logout");
          });
      }
    }
  };

  handleShowData = event => {
    event.preventDefault();
    let start = new Date(this.state.startDate);
    start.setHours(0, 0, 0, 0);
    let end = start.setDate(start.getDate() + 4);

    this.setState({
      openAlert: false,
      endDate: moment(end).format("YYYY-MM-DD")
    });

    let dateStart = new Date(this.state.startDate);
    dateStart.setHours(0, 0, 0, 0);
    let dateEnd = new Date(this.state.endDate);
    dateEnd.setHours(24, 0, 0, 0);

    let timeStart = moment(dateStart).format("YYYY-MM-DD HH:mm:ss");
    let timeEnd = moment(dateEnd).format("YYYY-MM-DD HH:mm:ss");

    this.setState({ loading: "Loading..." });

    fetchShiprtbt(this.state.ship_id, timeStart, timeEnd, this.state.source)
      .then(response => {
        let dataxx = this.normalizeTrackResults(response.data.results);

        if (dataxx.length > 1) {
          this.setState({ dataship: dataxx, loading: "" });
          this.props.pushShipTrack(this.buildTrackPayload(dataxx));
        } else {
          this.setState({ loading: "No Data" });
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: "No Data" });
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeSourceAis = event => {
    if (event.target.checked === true) {
      // this.props.pushSourceAis("AIS_MT");
      this.setState({ source: "AIS_MT", dataship: [] });
      this.setState({
        sourceAis: event.target.checked,
        sourceGPS: false,
        sourceGpsAis: false
      });
    }
  };

  handleChangeSourceGPS = event => {
    if (event.target.checked === true) {
      // this.props.pushSourceAis("GPS");
      this.setState({ source: "GPS", dataship: [] });
      this.setState({
        sourceGPS: event.target.checked,
        sourceAis: false,
        sourceGpsAis: false
      });
    }
  };

  handleChangeSourceGpsAis = event => {
    if (event.target.checked === true) {
      // this.props.pushSourceAis("GPSAIS");
      this.setState({ source: "GPSAIS", dataship: [] });
      this.setState({
        sourceGpsAis: event.target.checked,
        sourceGPS: false,
        sourceAis: false
      });
    }
  };

  handleClose = e => {
    this.setState({ openAlert: false });
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleKeyDown = e => {
  };

  renderDatanya = e => {
    if (this.state.dataship != []) {
      let selected = false;
      if (this.state.selectedRow == e.keynya) {
        selected = true;
      } else {
        selected = false;
      }

      return (
        <TableRow
          style={{ cursor: "pointer" }}
          hover
          selected={selected}
          onClick={() => {
            this.setState({ selectedRow: e.keynya });
            this.props.pushVesselPointTrack([
              e.lat,
              e.lon,
              e.date_created,
              e.speed
            ]);
          }}
        >
          <TableCell style={{ padding: 5 }}>
            <small>
              {moment(e.date_created).format("DD/MM/YYYY HH:mm:ss")}
            </small>
          </TableCell>
          <TableCell style={{ padding: 5 }}>
            <small>{parseFloat(e.lon).toFixed(3)}º</small>
          </TableCell>
          <TableCell style={{ padding: 5 }}>
            <small>{parseFloat(e.lat).toFixed(3)}º</small> <br />
          </TableCell>
          <TableCell style={{ padding: 5 }}>
            <small>{(parseInt(e.speed) * 0.1).toFixed(2)}</small>
          </TableCell>
        </TableRow>
      );
    }
  };

  render() {
    return (
      <Grid xs={12} sm={12} md={12} style={{ padding: 10 }}>
        <FormControl
          variant="outlined"
          size="small"
          fullWidth={true}
          style={{ paddingBottom: 6 }}
        >
          <TextField
            size="small"
            id="date"
            label="Start Date"
            type="date"
            variant="outlined"
            defaultValue={this.state.startDate}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              value: this.state.startDate,
              onChange: this.handleStartDate
            }}
          />
        </FormControl>
        <FormControl
          variant="outlined"
          size="small"
          fullWidth={true}
          style={{ paddingBottom: 6 }}
        >
          <TextField
            size="small"
            variant="outlined"
            id="date"
            label="End Date"
            type="date"
            defaultValue={this.state.endDate}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              value: this.state.endDate,
              onChange: this.handleEndDate
            }}
          />
        </FormControl>
        <FormControl
          variant="outlined"
          size="small"
          fullWidth={true}
          style={{ paddingBottom: 6, display: "contents" }}
        >
          <Typography style={{ paddingLeft: "4px" }}>Source: </Typography>
          <FormControlLabel
            style={{ paddingLeft: "5px" }}
            control={
              <Checkbox
                id="gps"
                checked={this.state.sourceGPS}
                onChange={this.handleChangeSourceGPS}
                name="checkedA"
                color="primary"
              />
            }
            label="GPS"
          />
          <FormControlLabel
            control={
              <Checkbox
                id="ais"
                checked={this.state.sourceAis}
                onChange={this.handleChangeSourceAis}
                name="checkedB"
                color="primary"
              />
            }
            label="AIS"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.sourceGpsAis}
                onChange={this.handleChangeSourceGpsAis}
                name="checkedC"
                color="primary"
              />
            }
            label="GPS&AIS"
          />
        </FormControl>
        <FormControl
          variant="outlined"
          size="small"
          fullWidth={true}
          style={{ paddingBottom: 6 }}
        >
          <Button variant="outlined" color="primary" onClick={this.handleShow}>
            Show
          </Button>
        </FormControl>
        <FormControl
          variant="outlined"
          size="small"
          fullWidth={true}
          style={{ paddingBottom: 6 }}
        >
          <Typography>{this.state.loading}</Typography>
        </FormControl>
        <FormControl
          variant="outlined"
          size="small"
          fullWidth={true}
          style={{ paddingBottom: 6 }}
        >
          <DownloadExcel
            datanya={this.state.dataship}
            dataship={this.state.shipname}
          />
        </FormControl>

        <TableContainer>
          <Table size="small" aria-label="a dense table" padding="none">
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Lon</TableCell>
                <TableCell>Lat</TableCell>
                <TableCell>Speed</TableCell>
              </TableRow>
            </TableHead>
            <TableBody striped={true}>
              {this.state.dataship.map(this.renderDatanya)}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ paddingBottom: 50 }} />
        <Dialog
          open={this.state.openAlert}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Alert"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Untuk tracking data 3 bulan kebelakang, maksimal rentang
              pengambilan data adalah 5 hari
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleShowData} color="primary" autoFocus>
              Show
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    );
  }
}

Tabtrack.propTypes = {
  pushShipTrack: PropTypes.array,
  pushShipTrack2: PropTypes.array,
  pushVesselPointTrack: PropTypes.array,
  pushSourceAis: PropTypes.string
};

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    basemap: state.basemap,
    sourceAis: state.sourceAis
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushShipTrack, pushVesselPointTrack, pushSourceAis, pushShipTrack2 }
  )(Tabtrack)
);
